import { Box, Divider, InputAdornment, Link } from '@mui/material';
import TextField from '@mui/material/TextField';
import CopyToClipboardButton from '@shared/components/others/CopyToClipboardButton/CopyToClipboardButton';
import PasswordTextField from '@shared/components/others/PasswordTextField/PasswordTextField';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { DeviceArchitecture, DutBookingCredentials } from '../types';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface BookingDeviceDutCredentialsProps {
    credentials: DutBookingCredentials[];
    deviceArchitecture: DeviceArchitecture;
}

const BookingDeviceDutCredentials: FC<BookingDeviceDutCredentialsProps> = ({ credentials, deviceArchitecture }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'flex-end' }}>
            <Box sx={{ maxWidth: '50%' }}>
                {credentials[2] && (
                    <>
                        <Link
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                width: 'min-content',
                                fontSize: '1rem',
                                mb: 1,
                            }}
                            component="a"
                            href={credentials[2].command}
                            target="_blank"
                        >
                            {credentials[2].command}
                            <OpenInNewIcon fontSize="small" />
                        </Link>
                    </>
                )}
                <TextField
                    sx={{ width: '100%' }}
                    margin="dense"
                    size="small"
                    disabled
                    label={
                        deviceArchitecture === 'x86'
                            ? `${credentials[2]?.label ?? ''}: ${credentials[0].label}`
                            : `${t('access_via_ssh')}: ${credentials[0].label}`
                    }
                    value={credentials[0].command}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CopyToClipboardButton textToCopy={credentials[0].command} />
                                </InputAdornment>
                            ),
                        },
                    }}
                />
                <PasswordTextField
                    showCopyButton
                    margin="dense"
                    size="small"
                    disabled
                    type="password"
                    label={t('password')}
                    value={credentials[0].password}
                />
            </Box>
            {credentials[1] && (
                <>
                    <Divider orientation="vertical" flexItem />
                    <Box>
                        <TextField
                            sx={{ width: '100%' }}
                            margin="dense"
                            size="small"
                            disabled
                            label={`${t('access_via_ssh')}: ${credentials[1].label}`}
                            value={credentials[1].command}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CopyToClipboardButton textToCopy={credentials[1].command} />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                        <PasswordTextField
                            showCopyButton
                            margin="dense"
                            size="small"
                            disabled
                            type="password"
                            label={t('password')}
                            value={credentials[1].password}
                        />
                    </Box>
                </>
            )}
        </Box>
    );
};

export default BookingDeviceDutCredentials;
